export default __webpack_public_path__ + "static/media/icon-warning.f4884e40.svg";